export default __webpack_public_path__ + "static/media/img9.e88fb01b.jpg";